module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "max-width": "480px"
    }
  }, [_c('div', {
    staticClass: "wxOauthResult-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "wxOauthResult-loading"
  }, [_c('div', [_c('img', {
    staticClass: "wxOauthResult-img",
    attrs: {
      "src": require("../../../static/wxOauth/wxOauthLogin.gif")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wxOauthResult-span"
  }, [_vm._v("微信授权登录中")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dc198d5c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/wxOauthResult.vue
// module id = 1601
// module chunks = 18